<template>
  <div class="page-container">
    <div v-if="operators" class="content">
      <slot name="top-nav"></slot>
      <div class="row">
        <div class="col-3">
          <h4 class="info-bar-1">Preparing...</h4>
          <div class="card-grid">
            <div
              class="collection-card-1 flash"
              v-for="card in inProgressCards"
              :key="card.uuid"
            >
              {{ card.id_number }}
            </div>
          </div>
        </div>
        <div class="col-3">
          <h4 class="info-bar-2">Please Collect</h4>
          <div class="card-grid">
            <div
              class="collection-card-2 flash"
              v-for="card in readyToHandoutCards"
              :key="card.uuid"
            >
              {{ card.id_number }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="logo">
            <b-img height="100" src="/static/img/gompels_logo.png" />
          </div>
          <div class="additional-image" v-if="carouselImages.length">
            <img
              :src="currentSlideUrl"
              alt="Carousel Slide"
              class="carousel-image"
            />
          </div>
        </div>
      </div>
      <footer class="footer">
        Average collection time: {{ formattedAvgCollectionTime }} min
      </footer>
    </div>
    <div v-else>
      <not-working 
        :show="true"
        text="Gompels Quick Collect is not currently available, please join the queue."
      />
    </div>
  </div>
</template>

<script>
import NotWorking from "@/core/components/not-working/NotWorking.vue";

export default {
  name: "BaseStatusLayout",
  components: { NotWorking },
  props: {
    operators: { type: Boolean, default: false },
    inProgressCards: { type: Array, required: true },
    readyToHandoutCards: { type: Array, required: true },
    carouselImages: { type: Array, default: () => [] },
    formattedAvgCollectionTime: { type: Number, default: 0 },
  },
  data() {
    return {
      currentIndex: 0,
      intervalId: null
    }
  },
  computed: {
    currentSlideUrl() {
      if (this.carouselImages.length) {
        return this.carouselImages[this.currentIndex].image
      }
      return ""
    }
  },
  mounted() {
    this.startCarousel()
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  watch: {
    carouselImages() {
      this.currentIndex = 0
    }
  },
  methods: {
    startCarousel() {
      this.intervalId = setInterval(() => {
        if (this.carouselImages.length > 0) {
          this.currentIndex =
            (this.currentIndex + 1) % this.carouselImages.length
        }
      }, 20 * 1000)  // in milliseconds
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.content {
  flex: 1;
}
.row {
  display: flex;
  width: 100%;
}
.col-3 {
  width: 25%;
  padding-left: 0px;
  padding-right: 8px;
}
.col-6 {
  width: 50%;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.collection-card-1 {
  font-size: calc(100% + 2.5vw);
  font-weight: bold;
  color: rgb(0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #b3e8e9;
  border-radius: 8px;
}
.collection-card-2 {
  font-size: calc(100% + 2.5vw);
  font-weight: bold;
  color: rgb(0, 0, 0);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #d6f7e0;
  border-radius: 8px;
}
.info-bar-1 {
  background: blue;
  color: white;
  font-size: calc(100% + 2.5vw);
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  margin-bottom: 20px;
}
.info-bar-2 {
  background: #0a8544;
  color: white;
  font-size: calc(100% + 2.5vw);
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  margin-bottom: 20px;
}
.footer {
  background: #0a8544;
  color: white;
  font-size: calc(100% + 5vw);
  font-weight: bold;
  width: 100%;
  height: 12vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.additional-image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 74vh;
  width: 100%;
  margin-top: 20px;
}
.additional-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
@keyframes flash {
  0% { background-color: #d6f7e0; }
  50% { background-color: #f9f9f9; }
  100% { background-color: #d6f7e0; }
}
.flash {
  animation: flash 0.2s ease-in-out 7;
}
.carousel-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}
</style>
